import service from './SystemService';

export const SETTINGS_REQUEST = 'SYSTEM/SETTINGS/REQUEST';
export const SETTINGS_FAILURE = 'SYSTEM/SETTINGS/FAILURE';
export const SETTINGS_SUCCESS = 'SYSTEM/SETTINGS/SUCCESS';

export const getSystemSettings = () => async (dispatch) => {
  dispatch({ type: SETTINGS_REQUEST });
  try {
    const settings = await service.getSettings();

    dispatch({
      type: SETTINGS_SUCCESS,
      payload: { settings },
    });
  } catch (e) {
    console.error(e);
    dispatch({ type: SETTINGS_FAILURE });
  }
};
